export default {
  lang: 'Italiano',
  homeScreen: {
    title: 'Le Isole Bahamas',
    subTitle: 'Pronti al decollo',
    stayConnected: 'Resta in contatto',
    comingSoon: 'Prossimamente',
    messages: 'Messaggi',
    subtitle: '',
  },
  glassWidgets: {
    errors: {
      requestFailed: 'Qualcosa è andato storto. Riprova più tardi.',
    },
    programStatus: {
      title: 'Il mio stato',
      loading: 'Caricamento…',
      yourRep: 'Il tuo Rep',
      myProfile: 'Il mio profilo',
      favorites: 'Preferiti',
      registeredOn: 'Iscritto il:',
      graduatedOn: 'Diplomato il:',
      totalBadgesEarned: 'Distintivi totali ottenuti:',
      lastBookingLogged: 'Ultima prenotazione registrata:',
      currentTier: 'Livello attuale',
      lastBadgeEarned: 'Ultimo distintivo ottenuto:',
      currentFocus: 'Obiettivo attuale:',
      changeProfilePicture: 'Cambia Foto del Profilo',
    },
    todaysfocus: {
      title: 'Obiettivo di oggi',
      empty: 'Nessun obiettivo per oggi',
      loading: 'Caricamento…',
      error: 'Qualcosa è andato storto',
      slideNavAria: 'Navigazione diapositive',
      slideAria: 'Diapositiva',
      carouselAria: 'Obiettivo di oggi',
    },
    welcome: 'Benvenuto!',
    welcomeBack: 'Bentornato, {firstName}!',
    notifications: {
      loading: 'Caricamento…',
      empty: 'Nessuna notifica',
    },
    achievements: {
      title: 'Premi & Concorsi',
      loading: 'Caricamento…',
      lastBooking: 'Ultima registrazione inviata',
      currentTier: 'Livello attuale',
      contestEntries: 'Totale partecipazioni ai concorsi',
      nightsBooked: 'Notti prenotate',
      totalRevenue: 'Fatturato totale dichiarato',
      noBookingData: 'Nessun dato di prenotazione disponibile.',
      notAvailable: 'N/D',
      fileUploadSuccess: 'Il file è stato caricato con successo.',
      quickSubmit: {
        title: 'Invio rapido',
        uploading: 'Caricamento…',
        clear: 'Cancella',
        submit: 'Invia',
        submitSuccessSimulated: 'Prenotazione inviata con successo',
      },
    },
  },
  notification: {
    newAndNow: 'Nuovo e Ora!',
    alert: 'Avviso',
    message: 'Messaggio',
    badge: 'Nuovo Badge',
    contest: 'Concorso',
    'content-update': 'Aggiornamento Contenuto',
    events: 'Eventi',
    other: 'Notifica',
    welcome: 'Benvenuto',
  },
  directoryView: {
    search: 'Cerca...',
    amountOfResults: 'Numero di risultati: ',
    filter: 'Filtra',
    filters: 'Filtri:',
    subFilter: 'Sottofiltro',
    category: 'Categoria',
    subcategory: 'Sottocategoria',
    resetFilters: 'Reimposta filtri',
    showResults: 'Mostra risultati',
    clear: 'Cancella',
    noResults: 'Nessun risultato trovato. Prova con una ricerca diversa.',
    resetMap: "Reimposta la mappa all'inizio >",
    viewNow: 'Visualizza ora >',
    viewWebsite: 'Visita il sito web',
    viewOnMap: 'Visualizza sulla mappa',
    amenities: {
      gym: 'Palestra/Centro Fitness',
      spa: 'Spa',
      meeting_room: 'Sale Riunioni/Conferenze',
      pools: 'Piscina',
      accessible_property: 'Camere Accessibili',
      bars: 'Bar/Lounge',
      golf: 'Golf/Minigolf',
      beachfront: 'Accesso Privato alla Spiaggia',
      restaurants: 'Ristorante',
      waterfront: 'Fronte Mare',
      villa_product: 'Villa',
      non_smoking_resort: 'Resort per Non Fumatori',
      four_star: '4 Stelle',
      five_star: '5 Stelle',
      four_star_diamond: '4 Stelle Diamond',
      five_star_diamond: '5 Stelle Diamond',
      kitchenette_extended_stay: 'Kitchenette/Soggiorno Prolungato',
      all_suite: 'Tutto Suite',
      family_friendly: 'Adatto alle Famiglie',
      casino: 'Casinò',
      downtown: 'Centro Città',
      on_strip: 'Sulla Strip',
      private_airstrip: 'Pista di atterraggio privata',
      fishing_lodge: 'Lodge di pesca',
      dive_center: 'Centro immersioni',
      selfCatering: 'Con angolo cottura',
      marina: 'Porto turistico',
    },
  },
  directoryProfileView: {
    website: 'Sito web:',
    phone: 'Telefono:',
    altPhone: 'Telefono alternativo:',
    tollFree: 'Numero verde:',
    fax: 'Fax:',
    address: 'Indirizzo:',
    about: 'Informazioni:',
    starRating: 'Classificazione a stelle:',
    cuisine: 'Cucina:',
    email: 'Email:',
    contactPerson: 'Persona di contatto:',
    experiences: 'ESPERIENZE',
    accommodationType: 'Tipo di alloggio:',
    amenitiesNumberOfRooms: 'Numero di camere: ',
    amenitiesTitle: 'Servizi:',
    socialsTitle: 'SOCIAL:',
    socialTripadvisor: 'TripAdvisor',
    socialYelp: 'Yelp',
    socialYoutube: 'YouTube',
    socialInstagram: 'Instagram',
    socialFacebook: 'Facebook',
    socialTwitter: 'X',
    socialPinterest: 'Pinterest',
    socialMedia: 'Social media',
    numberOfRoomsTitle: 'Numero di camere:',
    roomsCount: 'Camere: {count}',
    listingNotFound: 'Struttura non trovata',
  },
  directory: {
    view: 'Visualizza ora >',
    reset: 'Ripristina filtri >',
    results: 'Quantità di risultati',
    acco: 'Filtra per tipo di alloggio',
    price: 'Filtra per prezzo',
    island: 'Filtra per isola',
    additional: 'Filtri aggiuntivi:',
    accessibleproperty: 'Proprietà accessibile',
    beachfront: 'Spiaggia',
    casino: 'Casinò',
    divecenter: 'Dive Center',
    fishinglodge: 'Fishing Lodge',
    golf: 'Golf',
    marina: 'Marina',
    selfcatering: 'Self-Catering',
    waterfront: 'Lungomare',
    noResults: 'Nessun risultato trovato. prova con una ricerca diversa.',
    search: 'Cerca un annuncio...',
    back: 'indietro',
  },
  loginScreen: {
    title: 'Programma di formazione e abilitazione alla vendita per agenti di viaggio',
    welcome: {
      headerTop: 'Benvenuti al',
      headerBottom: 'Programma Specialista delle Bahamas',
    },
    version2custom: {
      defaultAmbassador: {
        step2: 'Fase 1: Creare un account',
        step3: 'Fase 2: Creare il profilo',
      },
      houstonInsider: {
        hospitalityCheckboxLabel:
          'Questo programma è attualmente riservato ai lavoratori del settore alberghiero con sede a Houston. Sebbene speriamo di ampliare i criteri di ammissibilità in futuro, si prega di notare che i partecipanti che non soddisfano i requisiti attuali potrebbero essere esclusi dal programma',
      },
      app1857: {
        fields: {
          howDiscoveredKLA: 'Come hai scoperto la Key Lime Academy?',
          tradeshowDetailLabel: 'Quale fiera o conferenza?',
          tradeshowDetailPlaceholder: 'Inserisci il nome della fiera o della conferenza',
          discoverVisitFloridaKeys: 'Sito web Visit Florida Keys',
          discoverSearchEngine: 'Motore di ricerca (ad es. Google, Yahoo)',
          discoverAiTool: 'Strumento/ricerca AI (ad es. ChatGPT, Perplexity)',
          discoverSocialMedia: 'Social media (ad es. Instagram, X, Facebook, LinkedIn)',
          discoverEmailNewsletter: 'E-mail o newsletter',
          discoverWordOfMouth: 'Passaparola',
          discoverTradeshowConference: 'Fiera o conferenza (indicaci quale evento)',
          discoverOtherTravproAffiliate: 'Altri siti affiliati a TravPRO',
        },
      },
      app1865: {
        fields: {
          topTravelType: 'Qual è il tipo di viaggio che vendi di più?',
          travelTypeAdventure: 'Avventura/Avventura Leggera/Spedizione',
          travelTypeAllInclusive: 'Tutto Incluso',
          travelTypeBusinessMice: 'Affari/MICE',
          travelTypeCultureExperiential: 'Cultura/Esperienziale',
          travelTypeCruise: 'Crociere',
          travelTypeFamilyMultiGen: 'Famiglia/Multigenerazionale',
          travelTypeRomance: 'Romance/Matrimonio/Luna di miele',
          travelTypeLuxury: 'Lusso',
          travelTypeRail: 'Treno',
          travelTypeTours: 'Tour',
          travelTypeWellness: 'Benessere/Salute/Spa',
          travelTypeLgbtq: 'LGBTQ+',
        },
      },
      app1826: {
        fields: {
          optMarketing:
            'Rimani in contatto con il team di professionisti del settore turistico e con i partner di questo programma per ricevere gli ultimi aggiornamenti.',
        },
      },
      app842: {
        fields: {
          segments: 'Quale/i segmento/i vende principalmente?',
          segmentLeisure: 'Leisure',
          segmentCorporate: 'Corporate',
          segmentGroup: 'Gruppi',
        },
      },
    },
    version2: {
      homeTitle: 'Vediamo se riusciamo a trovare un profilo esistente per lei nel nostro sistema.',
      homeTitleSub: "Inserite l'indirizzo e-mail che utilizzate di solito per accedere ai programmi di formazione.",
      noAccount: "Nessun account trovato ({email}), provare con un'altra e-mail o creare un account ora.",
      continueButton: 'Continua',
      success: 'Il tuo account è stato aggiornato con successo! Verrete reindirizzati a breve alla pagina iniziale.',
      successNewAccount:
        "Per completare la registrazione, riceverete un'e-mail di conferma per verificare il vostro account.",
      loginButton: 'Accesso',
      matchFound: 'Abbiamo trovato una corrispondenza, inserire la password per continuare.',
      magicLink: "Effettuare l'accesso tramite un link inviato via e-mail:",
      magicLinkButton: 'Richiesta di collegamento magico',
      magicLinkTitle:
        'Riceverete un link diretto al vostro indirizzo e-mail che vi consentirà di accedere immediatamente.',
      otherEmailButton: 'Invia',
      title:
        'Vi preghiamo di completare tutte le informazioni qui di seguito per creare il vostro profilo personale e le informazioni di contatto.',
      titleIndustry:
        'Vi preghiamo di completare tutte le informazioni qui di seguito per creare il vostro profilo personale e le informazioni di contatto.',
      register: 'Creare un account',
      agent: 'Consulente di viaggio',
      visitor: 'Visitatore del settore',
      ambassador: 'Ambasciatore',
      step1: 'Passo 1: Tipo di utente',
      step2: 'Fase 2: Creare un account',
      step3: 'Fase 3: Creare il profilo',
      marketingOptIn:
        'Siete sicuri di non essere interessati a rimanere in contatto con il team di travel trade di questo programma?',
      optIn: 'Sì, sono interessato',
      optOut: 'Non interessato',
      step2Sub1: 'Parlaci di te',
      step2Sub2: 'Parlateci della vostra attività',
      step2Sub3: 'Parlaci del tuo datore di lavoro',
      privacyHead: 'PREFERENZE DI COMUNICAZIONE',
      privacySub:
        'Selezionate le caselle sottostanti per assicurarvi di ricevere le comunicazioni più importanti dal team del settore viaggi del fornitore (aggiornamenti e annunci sui prodotti, premi, incentivi, FAM, ecc.) e le iniziative di networking e supporto alle vendite del settore viaggi di TravPRO Mobile.',
      privacy: 'Proteggiamo la vostra privacy e non vendiamo, abusiamo o tradiamo mai la vostra fiducia.',
      store: 'Scaricate facilmente questo programma dal vostro app store:',
      powered: 'ALIMENTATO DA',
      toastMessage: {
        forgotSuccess:
          'Abbiamo inviato per e-mail il link per la reimpostazione della password! Sarete reindirizzati alla pagina di accesso entro 10 secondi.',
        emailNotExisting: "L'indirizzo e-mail inserito non esiste.",
        magicLinkMessage: 'Attenda, la stiamo registrando in questo momento.',
        magicLinkError:
          'Non siamo riusciti a trovare il suo account nel nostro database, la preghiamo di accedere manualmente. Verrete reindirizzati entro 10 secondi.',
        magicLinkError1:
          "Non è stato possibile trovare un token valido, si prega di effettuare il login o di richiedere un nuovo link magico. Se il problema persiste, contattateci all'indirizzo: info@travpromobile.com.",
        magicLinkError2:
          'Non siamo riusciti a trovare il suo account nel nostro database, la preghiamo di accedere manualmente. Verrete reindirizzati entro 10 secondi.',
        magicLinkSuccess:
          "Controllate la vostra e-mail all'indirizzo {email}. C'è un link magico che vi farà accedere.",
        magicLinkErrorWait: 'Attendere 5 minuti tra le richieste di link magico.',
        emailNotFoundError:
          "L'indirizzo e-mail inserito non è presente nei nostri archivi. Si prega di verificare la presenza di errori ortografici o di creare un account.",
      },
      errors: {
        zipCodeNotFound: 'Codice postale non trovato, riprovare',
        zipCodeOnlyNumbers: 'ZipCode può contenere solo numeri',
        password: 'Inserire una password',
        passwordNotMatching: 'Le password inserite non corrispondono',
        passwordTooShort: 'La password deve essere di almeno 8 caratteri',
        emailExists:
          'Questo indirizzo e-mail esiste già o non è valido. Provare con un altro indirizzo e-mail o accedere al proprio account.',
        fillInAllFields: 'Compilare tutti i campi richiesti',
        fillInEmail: 'Inserite il vostro indirizzo e-mail.',
        emailNotExisting: "L'indirizzo e-mail inserito non esiste.",
      },
      fields: {
        forgotSubCopy: 'Avete dimenticato la password e volete cambiarla? ',
        forgotSubCopy2:
          "Volete evitare completamente la password? Vi invieremo un'e-mail con un link magico che vi farà accedere automaticamente al programma.",
        city: 'Città',
        companyName: 'Nome della società',
        role: 'Il vostro ruolo',
        description: "Quale descrive meglio l'attività della vostra azienda?",
        country: 'Paese',
        password: 'Password',
        passwordRegister: 'Scegliere la password (minimo 8 caratteri)',
        passwordConfirm: 'Conferma la password',
        firstName: 'Nome (dato)',
        lastName: 'Cognome (Famiglia)',
        agency: "Nome dell'agenzia",
        employer: "Nome dell'azienda del datore di lavoro",
        employerRole: 'Qual è la descrizione che meglio corrisponde al tuo ruolo?',
        employerYears: 'Da quanti anni risiedi nella zona in cui lavori?',
        title: 'Il vostro ruolo (selezionare uno)',
        company: 'Nome della società',
        select: "Selezionare un'opzione qui sotto",
        state: 'Stato',
        province: 'Provincia/Regione/Stato',
        zipCode: 'Codice postale',
        postalCode: 'Codice postale',
        affiliate: 'Qual è il vostro gruppo di appartenenza principale?',
        hostAgency: "L'agenzia ospitante?",
        ataCliaArc: 'Qual è il tuo numero ATA/CLIA/ARC?',
        executive: 'Esecutivo',
        management: 'Gestione',
        marketing: 'Marketing',
        sales: 'Vendite',
        coordinator: 'Coordinatore',
        opt: 'Rimanete in contatto con il team del settore viaggi di questo programma e ricevete gli aggiornamenti.',
        optMarketing: 'Rimanete in contatto con TravPRO per programmi ed eventi simili.',
        retail: 'Fronte del negozio al dettaglio',
        home: 'Agente a domicilio',
        independent: 'Contraente indipendente',
        host: 'Agenzia ospitante',
        call: 'Call center o agenzia web',
        other: 'Altro',
        describes: "Cosa descrive meglio l'attività sua e della sua agenzia?",
        invalidEmail: 'Inserisci un indirizzo email valido',
        roleDMO: 'DMO',
        roleEventEmployee: 'Dipendente di eventi',
        roleHotelEmployee: 'Dipendente di hotel',
        roleRestaurantBar: 'Dipendente di ristorante/bar',
        roleRetailService: 'Dipendente di vendita al dettaglio e servizi',
        roleTourActivity: 'Dipendente di tour e attività',
        roleTransportation: 'Dipendente dei trasporti',
        roleOther: 'Altro',
        yearsJustArrived: 'Appena arrivato (<6 mesi)',
        years1to5: 'Da 1 a 5 anni',
        years5to10: 'Da 5 a 10 anni',
        years10Plus: '10+ anni',
      },
    },
    forgot: 'Reimpostare la password',
    forgotCopylong:
      "Avete dimenticato la password? Cliccate sul pulsante qui sotto e vi invieremo un'e-mail per reimpostare la password.",
    forgotHeader:
      "Fornisci l'indirizzo email che hai utilizzato quando ti sei registrato per il tuo account Bahamas Specialist. Ti invieremo un'e-mail che ti permetterà di reimpostare la tua password",
    sellingPoints: {
      0: 'Apprendi, promuovi e vendi ovunque sei',
      1: 'Formazione multimediale su tutti i dispositivi',
      2: 'Attestato di completamento',
      3: 'Presentazioni di vendita già pronte',
      4: 'Materiali promozionali ad alto impatto',
      5: 'Consigli esperti e promozioni',
      6: 'Elenco prodotti in tempo reale',
      7: 'Notizie tempestive e aggiornamenti',
    },
    emailPrompt: 'Inserisci  indirizzo email e password per confermare che sei un agente di viaggio',
    tAndC: {
      agree: 'Continuando a navigare accetti la nostra ',
      privacyPolicy: 'politica sulla privacy',
      and: ' e ',
      termsConditions: 'i nostri termini e condizioni',
    },
    fields: {
      agency: 'Agenzia',
      email: 'Email',
      password: 'Password',
      passwordConfirm: 'Conferma la password',
      firstName: 'Nome',
      lastName: 'Cognome',
      agencyName: "Nome dell'agenzia",
      stateProvince: 'Stato/Provincia',
      required: 'Obbligatorio',
      invalidEmail: 'Indirizzo email non valido',
      opt: 'Resta in contatto! Sì, desidero ricevere comunicazioni su notizie, eventi, incentivi, tour per operatori turistici e altro!',
      forgot: 'Reimpostare la password',
      forgotCopylong:
        "Avete dimenticato la password? Cliccate sul pulsante qui sotto e vi invieremo un'e-mail per reimpostare la password.",
    },
    noAgent: {
      noAgentButton: 'Non sono un consulente',
      title: 'Grazie per il tuo interesse per le Bahamas.',
      messageWeb:
        'I contenuti di questo sito sono riservati esclusivamente agli agenti di viaggio. Per saperne di più sulle Bahamas visita:',
      messageMobile:
        "Alcuni contenuti di quest'applicazione sono riservati esclusivamente agli agenti di viaggio, ma puoi visualizzare un'anteprima dell'applicazione cliccando su \"Continua\".",
      continue: 'Continua',
      visitWebsite: 'Visita il sito web',
    },
    newUser: 'Nuovo utente',
    register: 'Registrati',
    registered: 'Questo indirizzo email è già registrato',
  },
  welcomeScreen: {
    title: 'Benvenuto nella Guida commerciale per specialisti delle Bahamas',
    helloUser: 'Salve {{nome}}',
    hello: 'Salve,',
    fromAgency: 'di {{agenzia}}',
    notUser: 'Non sei {{nome}}?',
    introOnline:
      "Allenati subito online o precarica i contenuti in modo che siano sempre disponibili per l'uso offline!",
    introOffline:
      'Hai già precaricata la versione più recente. Inizia a fare formazione o a vendere quando e dove vuoi!',
    startTraining: 'Inizia la formazione',
    continueTraining: 'Continua la formazione',
    graduated: 'Congratulazioni!',
    downloader: {
      preload: 'Precaricamento',
      stop: 'Stop',
      init: 'Inizializzazione',
      lastUpdate: 'Ultimo aggiornamento',
    },
  },
  trainingScreens: {
    review: 'Rivedi',
    start: 'Inizia',
    continue: 'Continua',
    restart: 'Riavvia',
    durationInMinutes: '{Numeri} minuti',
    percentageComplete: '{numero} completato',
    unlock: 'Sblocca questo capitolo completando il capitolo {numero}.',
    unlockFoundation: 'Sblocca questo capitolo completando il capitolo {number}.',
    unlockSpecialization: 'Sblocca ottenendo il tuo certificato.',
    unlockPartners: 'Sblocca ottenendo il tuo certificato.',
    unlockRetain: 'Sblocca questo capitolo completando la fondazione in {name}.',
    unlockSubtitle: 'Sblocca altri capitoli completando i capitoli di formazione.',
    allUnlocked: 'Hai completato tutti i capitoli !',
    certificate: 'Attestato',
    courseComplete: 'Continua',
    endReached: 'Hai raggiunto la fine',
    retainEnd:
      "Usa la barra superiore per navigare all'interno di questo capitolo o clicca sul tasto indietro per tornare alla panoramica.",
    watchListenRead: 'Leggi, guarda e scopri di più',
    trouble: 'Sembra che ci siano dei problemi, rileggi il contenuto delle pagine precedenti e riprova.',
    confirm: 'Conferma la risposta',
    choose: 'Scegli una risposta',
    skip: 'Invio',
    viewAllTitle: 'Suggerimento per la formazione',
    viewAll:
      'Per passare alla pagina successiva, assicurati di aver esaminato tutti i contenuti della pagina. Ciò può includere la visione di tutti i video, il clic sulle icone per visualizzare i materiali supplementari e la risposta corretta alle domande. Queste informazioni utili sono state fornite per migliorare la tua formazione e assicurarti di ottenere lo status PRO.',
    fillBlanks: 'Riempi lo spazio o gli spazi in bianco',
    next: 'Domanda successiva',
    retry: 'Riprova',
    fastTrackContinue: 'Continua Fast Track',
    fastTrackMoveToFull: 'Annulla Fast Track',
    fastTrackPrompt:
      'Ti consideri già un esperto BVI? Vorresti tentare di ottenere la tua certificazione tramite Fast Track? Un tentativo, 15 domande, voto minimo di superamento: 80% (B).',
    grading: 'Il tuo punteggio finale è: {punteggio}',
  },
  nav: {
    home: 'Home',
    train: 'Esercitati',
    learn: 'Esercitati',
    retain: 'Ricorda',
    directory: 'Elenco alberghi',
    showcases: 'Vetrine',
    destinationShowcases: 'Destinazione\nVetrine',
    promote: 'Promuovi',
    sell: 'Vendi',
    info: 'Informazioni',
    rewards: 'Ricompense',
    achievements: 'Traguardi',
    media: 'Media',
    favorites: 'Preferiti',
    contact: 'Contatto',
    reportCard: 'Visualizza diploma',
    accountSettings: 'Impostazioni account',
    changeProfileImage: 'Cambia immagine del profilo',
    messages: 'Messaggi',
    search: 'Cerca',
    manageImpersonation: 'Impersona utente',
  },
  impersonateView: {
    title: 'Impersona utente',
    description:
      "Inserisci l'indirizzo email dell'utente che vuoi impersonare. Devi già essere autenticato affinché l'impersonazione funzioni.",
    returnToApp: "Torna all'app",
    emailLabel: 'Indirizzo email',
    startImpersonation: 'Avvia impersonazione',
    impersonating: 'Impersonazione in corso…',
    confirmImpersonation: 'Conferma impersonazione',
    confirming: 'Conferma in corso…',
    endImpersonation: 'Termina impersonazione',
    ending: 'Terminazione in corso…',
    currentlyImpersonating: "Stai attualmente impersonando {email}. Puoi terminare l'impersonazione qui sotto.",
    missingEmail: 'Inserisci un indirizzo email da impersonare.',
    tokenFetched: 'Token di impersonazione ottenuto per {email}. Verifica del profilo prima della conferma.',
    previewFailed: "Impossibile recuperare il profilo utente per l'impersonazione.",
    startFailed: "Impossibile avviare l'impersonazione. Riprova.",
    confirmFailed: "Impossibile confermare l'impersonazione. Riprova.",
    endFailed: "Impossibile terminare l'impersonazione. Riprova.",
    previewLabel: 'Risposta di impersonazione',
  },
  contentHeaders: {
    train: 'Esercitati',
    retain: 'Ricorda',
    subapps: 'Moduli Specialista delle Bahamas',
    maintrainings: "L'ESSENZIALE",
    subtrainings: 'MODULI DI SPECIALIZZAZIONE',
    fastTrack: 'Fast Track',
  },
  pageDescriptions: {
    train: 'Informati, impegnati e diventa esperto.',
    trainAmbassador: 'Informati, impegnati e diventa un ambasciatore esperto.',
    retain:
      "Benvenuto in Ricorda. Una volta completata la formazione, questa sarà la tua risorsa di riferimento per conservare le tue conoscenze specialistiche e potenziare le tue attività di vendita. Utilizza quest'area per rispondere in modo competente a domande sui prodotti o anche per improvvisare presentazioni di vendita, in qualsiasi momento, ovunque ti trovi e da qualsiasi dispositivo.",
    retainAmbassador:
      "Benvenuto in Ricorda. Una volta completata la formazione, questa sarà la tua risorsa di riferimento per conservare le tue conoscenze specialistiche e potenziare le tue attività di vendita. Utilizza quest'area per rispondere in modo competente a domande sui prodotti o anche per improvvisare presentazioni di vendita, in qualsiasi momento, ovunque ti trovi e da qualsiasi dispositivo.",
    promote: 'Inizia la conversazione con i tuoi clienti e potenziali tali',
    promoteAmbassador:
      'Qui trovi risorse per restare aggiornato sugli elementi essenziali del turismo, oltre a contenuti interessanti da condividere con i visitatori per aiutarli a vivere il meglio della destinazione.',
    sell: 'Rispondi alle domande dei tuoi clienti e concludi la vendita.',
    favorites: 'Controlla i tuoi contenuti preferiti',
    search: 'Guarda tutti i contenuti',
    subapps: 'Moduli Specialista delle Bahamas',
    maintrainings: 'Completa questi moduli essenziali per ottenere il diploma.',
    subtrainings: 'Sali di livello e guadagna un distintivo per ogni modulo sottostante.',
    fastTrack: 'Sei attualmente nel Fast Track. Completalo per ottenere il tuo voto!',
  },
  general: {
    chapter: 'Capitolo ',
    next: 'Avanti',
    yes: 'Sì',
    no: 'No',
    previous: 'Precedente',
    submit: 'Invia',
    back: 'Indietro',
    close: 'Chiudi',
    page: 'Pagina',
    search: 'Cerca',
    selectLanguage: 'Seleziona lingua',
    showRoom: 'Vetrina',
    showcase: 'Vetrine',
    logIn: 'Accedi',
    logOut: 'Esci',
    viewItem: 'Vedi {inserire}',
    imageNotFound: 'Immagine non trovata',
    noResultsFor: 'Non è stato trovato alcun risultato per: {{chiave di ricerca}}',
    noFavorites: 'Non hai ancora preferiti.',
    noMessages: 'Non hai ancora ricevuto messaggi!',
    resultsFor: 'Risultati per: {{chiave di ricerca}}',
    showAll: 'Mostra tutto',
    connectionError: 'Errore di connessione',
    alreadyExists: 'Già esiste',
    pageNotFound: '404 Pagina non trovata!',
    oops: 'Oh oh',
    overview: 'Torna alla panoramica',
    complete: 'Continua',
    courseComplete: 'Corso completato!',
    chapterComplete: 'Capitolo completato!',
    message: '{Numero} Messaggio',
    messagePlural: '{Numero} Messaggi',
    viewBadge: 'Vista',
    downloadBadge: 'Scarica Badge',
    viewBadge2: 'Badge',
  },
  itemTypes: {
    image: 'Immagine',
    brochure: 'Raccolta',
    layout: 'Layout',
    web: 'Sito Web',
    pdf: 'PDF',
    carousel: 'Raccolta',
  },
  questions: {
    dials: 'Ruota i selettori in base alla risposta',
    fitb: 'Riempi lo spazio o gli spazi in bianco',
    flip: 'Modifica il numero in base alla risposta',
    multipleChoice: 'Scegli la risposta o le risposte',
    slider: 'Scegli la risposta  usando il cursore',
    map: 'Rispondi alla domanda cliccando sulla posizione corretta sulla mappa',
    dropdown: 'Scegli…',
    true: '1',
    false: 'Falso',
    arrangeTheWords: "Clicca sulle parole nell'ordine corretto per completare la frase, poi clicca su Invia:",
    matchTheSentence:
      'Clicca su una frase a sinistra e poi sulla corrispondente a destra. Abbina tutte le coppie per completare la domanda.',
  },
  reportCard: {
    download: 'Scarica',
    email: 'Email',
    print: 'Stampa',
  },
  cookies: {
    consent: 'CONSENTI',
    optout: 'Opt-out',
    settings: 'Impostazioni privacy',
    message:
      "Non ci hai detto nulla sulle tue preferenze in materia di privacy! Non c'è problema, ma vorremmo offrirti la migliore esperienza di utilizzo della Guida commerciale.",
    disabled: "Sembra che tu abbia disabilitato l'uso dei cookies.",
    use: "{{nome app}} richiede l'uso di cookies per offrirti un'esperienza ottimale.",
    details: 'A cosa servono i cookies?',
    enable: 'Guarda come abilitare i cookies {{qui}}.',
    here: 'qui',
  },
  notLoggedIn: {
    super: "Non hai effettuato l'accesso",
    title: "Devi effettuare l'accesso per visualizzare questo contenuto",
    guest: 'Ospite',
  },
  demo: {
    message:
      'Questo sito web è una dimostrazione del prodotto finale. È attualmente in fase di sviluppo e non è un prodotto completo.',
    consent: 'Ho capito!',
  },
  share: {
    header: 'Condividi questa risorsa sui tuoi social media preferiti!',
    download: 'Scarica',
    button: 'Condividi',
  },
  sharing: {
    copyURL: 'Copia link',
    copied: 'Copiato',
  },
  breadCrumbs: {
    page: 'Pagina',
  },
  onMobile: {
    header: "Sembra che tu stia cercando di accedere all'applicazione {nome app} da un dispositivo mobile.",
    body: "Per scaricare questo programma è sufficiente visitare l'app store e cercare {nome app} o cliccare su uno dei pulsanti sottostanti.",
    benefits: {
      1: 'Attestato di completamento',
      2: 'Materiale di marketing gratuito e di alta qualità',
      3: 'Qualificati per partecipare ai tour per gli operatori turistici',
      4: 'Informazioni e risorse sulle vendite ad alto impatto',
      5: "Accesso all'applicazione mobile della Guida commerciale",
      6: 'Consigli di vendita',
      header: 'Questo ti fornirà:',
    },
  },
  custom: {
    splitUsers: 'Sono un…',
    brandAmbassador: 'Portavoce della marca',
    travelPro: 'Agente di viaggio',
  },
  rewards: {
    lockedPopupNotGraduated:
      'Accedi a questi vantaggi esclusivi riservati ai diplomati completando la formazione e ottenendo il tuo certificato ',
    menu: {
      home: 'Home\nRicompense',
      homeAmbassador: 'Panoramica',
      achievements: 'Risultati\nFormazione',
      bookings: 'Incentivi\nBadge',
      form: 'Invia\nPrenotazioni',
    },
    rewards: 'Premi',
    title: 'Ti diamo il benvenuto nel Centro premi e risultati',
    subheader: 'Monitora e condividi i risultati e gli incentivi della formazione',
    titleAmbassador: 'Benvenuto nel Centro dei Traguardi',
    subheaderAmbassador:
      'Tieni traccia dei tuoi traguardi di formazione, riscatta i tuoi premi e condividi le tue certificazioni.',
    button: 'Invia la tua prenotazione',
    viewAllBookings: 'Prenotazioni',
    viewDashboard: 'Dashboard punti',
    viewRewards: 'Panoramica',
    overview: {
      valid: '*Le prenotazioni inserite sono valide solo dopo il completamento del viaggio del cliente.',
    },
    home: {
      entries: 'Voci attuali',
      trainingAchievements: 'RISULTATI DELLA FORMAZIONE',
      trainingAchievementsText:
        'Tieni traccia dei tuoi progressi, delle certificazioni e dello stato dei premi da questa pagina. Potrai scaricare e condividere il tuo diploma di specialista degli Stati Uniti, così come tutti i badge che hai guadagnato in Esperienze e Specializzazioni dei partner.',
      trainingAchievementsTextNoMetallic:
        'Tieni traccia dei tuoi progressi e dello stato delle certificazioni da questa pagina. Potrai anche scaricare e condividere il tuo diploma, così come tutti i badge che hai guadagnato.',
      bookingContests: 'DASHBOARD INCENTIVI',
      bookingContestsText:
        'Monitora e gestisci i programmi di incentivi attuali in tutta facilità dalla Dashboard incentivi. ',
      submitBooking: 'INVIA LE PRENOTAZIONI',
      submitBookingText:
        'Da questa pagina potrai inviare le prenotazioni per includerle in Incentivi per le prenotazioni.',
      currentContest: 'INCENTIVI ATTUALI',
      noContests: 'Attualmente non sono presenti Incentivi per i badge.',

      contestTerms: 'i nostri termini e condizioni',
      noContest: 'Il concorso non è attualmente disponibile.',
    },
    bookingsView: {
      title: 'Prenotazioni',
      infoMessage:
        "Ordinare utilizzando i pulsanti in alto e fare clic su qualsiasi record per gestire i dettagli dell'invio. Tutte le iscrizioni in sospeso saranno verificate entro 72 ore",
    },
    leaderboardScreen: {
      prizes: 'Premi',
      tAndC: 'Offerta soggetta a termini e condizioni*',
    },
    dashboardView: {
      title: 'Dashboard incentivi',
      subtitle: 'Tieni traccia delle tue attività relative agli incentivi da questa pagina.',
      badge: 'Incentivi per i badge',
      activity: 'Incentivi per le prenotazioni',
      manage: 'Gestisci prenotazioni',
      manageSub:
        'Seguite le prenotazioni attuali qui sotto, oppure visualizzate le prenotazioni archiviate utilizzando il menu a tendina.',
      noBadgeIncentives: 'Attualmente non sono presenti Incentivi per i badge.',
      noBookings: 'Nessun record da visualizzare.',
      state: {
        approvedEntries: 'Voci Approvate',
        pendingEntries: 'Iscrizioni in Sospeso',
        declinedEntries: 'Voci Rifiutate',
        viewAll: 'Visualizza Tutti',
      },
      columns: {
        wholesaler: 'Grossista',
        clientLastName: 'Cognome del Cliente',
        totalCostUsd: 'Costo Totale USD',
        hotelName: "Nome dell'Hotel",
        hotelConfirmNumber: 'Numero di Conferma Hotel',
        flightNumber: 'Numero di Volo',
        typeOfBooking: 'Tipo di Prenotazione',
        checkIn: 'Check-In',
        checkOut: 'Check-Out',
        status: 'Stato',
      },
      currentYear: 'Anno Corrente',
      archivedBookings: 'Prenotazioni Archiviate',
    },
    bookingForm: {
      title: 'Modulo di invio prenotazione',
      subTitle: 'Inserisci la tua prenotazione:',
      required: '* Indica un campo obbligatorio',
      email: "Email dell'agente",
      agentFirstName: "Nome dell'agente",
      agentLastName: "Cognome dell'agente",
      company: "Nome dell'azienda",
      iata: 'IATA/CLIA #',
      stateProvince: 'Stato/Provincia',
      postalCode: 'Codice postale *',
      country: 'Paese',
      bookingNumber: 'Numero di conferma della prenotazione',
      numberOfGuests: 'Numero di ospiti adulti',
      bookingDate: 'Data della prenotazione',
      tourOperator: 'Grossista',
      firstName: 'Nome',
      clientLastName: 'Cognome del cliente',
      guestLastName: "Cognome dell'ospite",
      confirmationNumber: "Numero di conferma dell'hotel",
      flightNumber: 'Numero di volo',
      hotelName: "Nome dell'hotel",
      guests: 'Numero di passeggeri',
      select: "Seleziona un'opzione",
      wholesaler: 'Grossista',
      arrivalDate: 'Data di check-in',
      departureDate: 'Data di check-out',
      lengthOfStay: 'Durata del soggiorno (in notti)',
      totalNights: 'Totale Notti',
      rooms: 'Numero di camere',
      stay: 'Durata del soggiorno (in notti)',
      airline: 'Compagnia aerea / Vettore (codice a 2 lettere)',
      originAirport: 'Aeroporto di origine (codice a 3 lettere)',
      destination: 'Destinazione / Isola (codice a 3 lettere)',
      cost: 'Costo totale della prenotazione (usare solo decimali)',
      totalCost: 'Costo Totale',
      file: 'Caricamento prova RezSnap™',
      disclaimer: '* Campi obbligatori',
      button: 'Invia la tua prenotazione',
      sub: 'Le tue informazioni',
      sub2: 'Informazioni sulla prenotazione',
      numberOfPassengers: 'Numero di Passeggeri',
      accommodationBooked: 'Resort/Hotel/Alloggi prenotati',
      accommodationCharterCompany: 'Hotel, ville, società di noleggio',
      propertyCharterCompany: 'Immobili / Società di noleggio',
      typeofBooking: 'Tipo di prenotazione',
      dragAndDrop: 'Trascina e rilascia alcuni file qui, oppure fai clic per selezionare i file',
      acceptedFiles: 'Saranno accettati solo file .jpeg, .png e .pdf. La dimensione massima del file è di 100 MB.',
      group: 'Gruppo',
      fit: 'FIT',
      missingRequiredFields: 'Compilare tutti i campi richiesti',
      invalidNumber: 'Deve essere un numero maggiore di 0.',
    },
    bookingFormCustom: {
      app1781: {
        fields: {
          previousVisits: 'Numero di Visite Precedenti ai Caraibi Messicani',
          ambassadorReferralHeader: 'Segnalazione Ambasciatore',
          referralFirstName: 'Nome',
          referralFirstNamePlaceholder: 'Nome (opzionale)',
          referralLastName: 'Cognome',
          referralLastNamePlaceholder: 'Cognome (opzionale)',
          referralEmail: 'Email',
          referralEmailPlaceholder: 'Email (opzionale)',
        },
      },
      app1439: {
        fields: {
          preOrPostCruise: 'Questa prenotazione è per un soggiorno pre o post crociera?',
          tripPurpose: 'Scopo del viaggio',
          departureAirport: 'Aeroporto di partenza (codice a 3 lettere)',
        },
      },
    },
    TermsAndConditions: {
      title: 'Termini e Condizioni',
      button: 'Indietro',
    },
    thankYouPage: {
      thanks: 'Grazie',
      congrats: 'Congratulazioni, ',
      body: 'abbiamo ricevuto la tua prenotazione, che è stata inviata al supervisore della campagna per la verifica.',
      link: 'Ricorda che per essere eletti vincitori è necessario aver completato il programma Base di USA Discovery Program',
    },
  },
  badgeView: {
    title: 'Risultati della Formazione',
    subtitle:
      'Tieni traccia dei tuoi progressi nella formazione, delle certificazioni e dello stato delle ricompense metalliche in questa pagina. Potrai anche scaricare e condividere il tuo diploma {program_name_short}, così come qualsiasi badge che hai ottenuto.',
    subtitleNoMetallic:
      'Tieni traccia dei tuoi progressi nella formazione e dello stato delle certificazioni in questa pagina. Potrai anche scaricare e condividere il tuo diploma {program_name_short}, così come qualsiasi badge che hai ottenuto.',
    badgeDisplayTitle: 'Stato di Raggiungimento Metallico',
    badgeAchievement:
      'Hai raggiunto lo stato {rank}! Clicca sull’icona a destra per visualizzare e condividere il tuo stato.',
    bronze: 'Bronzo',
    silver: 'Argento',
    gold: 'Oro',
    platinum: 'Platino',
    complete: 'COMPLETATO',
    diploma: 'Diploma',
    chapterBadges: 'Badge di Specializzazione',
    partnerBadges: 'Badge Partner',
    tierRewards: 'Premi di livello',
    click: 'Clicca ',
    here: 'qui',
    bronzeReward: ' per accedere al tuo esclusivo premio BRONZO.',
    silverReward: ' per accedere al tuo esclusivo premio ARGENTO.',
    goldReward: ' per accedere al tuo esclusivo premio ORO.',
    bronzeRewardTitle: 'Premio Stato Bronzo',
    silverRewardTitle: 'Premio Stato Argento',
    goldRewardTitle: 'Premio Stato Oro',
  },
  badgeDisplay: {
    status: 'Stato di Raggiungimento della Formazione',
  },
  tierCard: {
    achieved: 'Raggiunto',
    modules: 'moduli',
    sales: 'Vendite',
    bookings: 'Prenotazioni',
    or: 'o',
    workingToward: 'Lavorando verso',
    currentTier: 'Livello Attuale',
    workingTowardBronze: 'Completa la certificazione per raggiungere lo stato Bronzo!',
    expiresIn: 'Scade tra',
    days: 'giorni',
    expiringToday: 'Scade oggi!',
    expiryDate: 'Data di Scadenza',
    nextTier: 'Prossimo Livello',
    nextGoal: 'Prossimo Obiettivo',
    allTiers: 'Tutti i Livelli',
    bronzeDescription: 'Premia i consulenti che completano le basi e mostrano impegno iniziale.',
    silverDescription: 'Riconosce i consulenti che vendono costantemente e rimangono coinvolti.',
    goldDescription: 'Premia i migliori performer profondamente impegnati nella vendita.',
    title: {
      bronze: 'Bronzo',
      silver: 'Argento',
      gold: 'Oro',
    },
    requirement: {
      bronze: 'Completa la Certificazione Specialista Bahamas',
      silver: 'Guadagna $5.000+ in vendite di viaggi alle Bahamas o 5+ prenotazioni',
      gold: 'Guadagna $15.000+ in vendite di viaggi alle Bahamas o 15+ prenotazioni',
    },
    tierCopy: 'Congratulazioni! Hai raggiunto lo stato {tier}!',
  },
  search: {
    pages: 'Pagine',
    resources: 'Risorse',
  },
  categories: {
    all: 'Tutto',
    accommodations: {
      accommodations: 'Alloggi',
      bedbreakfast: 'Bed & Breakfast',
      campgroundsrvparks: 'Campeggi e Aree Camper',
      condo: 'Condominio',
      hotel: 'Hotel',
      vacationrentals: 'Case Vacanza',
    },
    attractions: 'Attrazioni',
    dining: 'Ristorazione',
  },
  profileImageView: {
    currentImage: 'La tua immagine del profilo attuale:',
    uploadImage: 'Carica la tua immagine del profilo:',
    chooseAFile: 'Scegli un file…',
    cancel: 'Annulla',
    backButton: 'Torna indietro',
    uploadButton: "Carica l'immagine del profilo",
    saveButton: 'Salva questa immagine del profilo',
    fileTooLargeTitle: 'Dimensione del file caricato superata',
    fileTooLargeText: 'La dimensione massima consentita per il caricamento delle immagini è di 10 MB',
  },
  FastTrackView: {
    incorrectAnswer: 'Non è corretto.',
    question: 'Q{current}/{total}',
    questionCounter: '{current} di {total} domande',
    score: 'Punteggio: {correct}/{total}',
    nextIn: 'Avanti tra {count}s',
    goToNextQuestion: 'Vai alla prossima domanda',
    gradeEarned: 'Voto ottenuto',
    correct: 'Corretto',
    completeFastTrack: 'Completa Fast Track',
    beginFullTraining: 'Inizia la formazione completa',
    fastTrackComplete: 'Fast Track completato!',
    fastTrackNotPassed: 'Fast Track non superato',
    downloadDiploma: 'Scarica diploma',
    resultSuccessMessage: 'Congratulazioni — hai superato il Fast Track e guadagnato il tuo diploma!',
    resultAchievementsPrefix: " Puoi accedere al tuo diploma nell'area ",
    resultAchievementsLinkText: 'Traguardi di formazione',
    resultAchievementsSuffix: '.',
    resultFailureMessage:
      'Purtroppo non hai superato il Fast Track. È limitato a un tentativo per utente — ma puoi comunque guadagnare il tuo diploma! Segui la formazione completa per approfondire le tue conoscenze e completala al tuo ritmo.',
  },
  smartAssist: {
    title: 'TA SmartAssist',
    pastConversations: 'Conversazioni precedenti',
    showNextSuggestionsAria: 'Mostra altri suggerimenti',
    headingAria: 'Apri TA SmartAssist',
    headingResumeAria: 'Riprendi la conversazione',
    homePlaceholder: 'Ask anything about travel in {destinationLabel}…',
    recentConversations: 'Conversazioni recenti',
    previousConversations: 'Conversazioni precedenti',
    noRecentConversations: 'Nessuna conversazione recente',
    deleteConversationAria: 'Elimina conversazione',
    chatSubtitle: 'Ask TA Smart Assist Anything About Travel in {destinationLabel}',
    startNewConversationAria: 'Nuova conversazione',
    sourcesFromApp: 'Fonti',
    loadingConversation: 'Caricamento conversazione…',
    welcomePrompt: 'Ask any travel related questions about {destinationLabel}',
    loadingResponse: 'Elaborazione…',
    messageLimitReached: 'Limite messaggi raggiunto',
    messageRemaining: '{remaining} messaggio rimanente',
    messagesRemaining: '{remaining} messaggi rimanenti',
    quotaBarAria: '{remaining} di {total} messaggi rimanenti',
    resetsAt: 'Ripristino il {resetLabel}',
    quotaChaptersPrompt: 'Earn certification for unlimited usage.',
    chatPlaceholder: 'Ask any travel related questions…',
    greetingFallback: 'Hi there',
    greetingName: 'Hi {firstName}',
    defaultDestination: 'questa destinazione',
    appNotReady: "L'app non è ancora configurata.",
    signInRequired: 'Accedi per continuare.',
    genericError: 'Qualcosa è andato storto. Riprova.',
    requestFailed: 'Richiesta fallita. Riprova.',
    sourceFallback: 'Fonte',
    fallbackSuggestions: {
      bestBeaches: 'Migliori spiagge',
      familyActivities: 'Attività in famiglia',
      hiddenGems: 'Gemme nascoste',
      roadTrips: 'Viaggi in auto',
      dining: 'Migliori ristoranti',
      events: 'Prossimi eventi',
    },
    structured: {
      confidenceThreshold: 'Attendibilità',
      confidenceThresholdPercentAria: 'Attendibilità: {percent}%',
      recommendation: 'Raccomandazione',
      alignment: 'Verifica di allineamento',
      tailor: 'Per personalizzare',
      tips: 'Suggerimenti di efficienza',
    },
  },
  imageGallery: {
    noticeTitle: "Avviso sull'uso delle immagini",
    noticeText:
      'Tutte le immagini sono concesse in licenza esclusivamente a {clientName} e non possono essere utilizzate senza autorizzazione',
  },
  toolbox: {
    completion: "Completa L'ESSENZIALE per sbloccare questo elemento",
  },
};
